import { Check, X } from "lucide-react";
import { ReportButton } from "@/components/quiz/ReportButton";

export function QuizReview({ attempt, onlyMissed }) {
  return (
    <div className="space-y-3 fade-in" data-testid={onlyMissed ? "quiz-why-review" : "quiz-review"}>
      {attempt.questions.map((q, i) => {
        const mine = attempt.answers[i];
        const right = mine === q.correct_index;
        if (onlyMissed && (right || q.category_label !== onlyMissed)) return null;
        return (
          <div key={i} className="card p-4" data-testid={`quiz-review-item-${i}`}>
            <div className="flex items-start gap-3">
              <span className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${right ? "bg-[#10B981]" : "bg-[#EF4444]"}`}>
                {right ? <Check size={14} strokeWidth={3} /> : <X size={14} strokeWidth={3} />}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <div className="text-[11px] uppercase tracking-wider text-[#71717A] truncate">{q.category_label}</div>
                  <ReportButton attemptId={attempt.id} index={i} reported={(attempt.reported || []).includes(i)} testid={`quiz-review-report-${i}`} />
                </div>
                <p className="font-semibold leading-snug">{q.question}</p>
                {!right && mine != null && (
                  <p className="text-sm mt-2.5 text-[#FCA5A5]"><span className="text-[#71717A]">You: </span>{q.options[mine]}</p>
                )}
                <p className="text-sm mt-1.5 text-[#6EE7B7]"><span className="text-[#71717A]">Answer: </span>{q.options[q.correct_index]}</p>
                <p className="text-sm text-[#A1A1AA] mt-2 leading-relaxed">{q.explanation}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
